<template>
  <div>
    <template v-if="place">
      <template v-if="!currentUser.isTechnician">
        <p class="page-subtitle">Miscela caffè</p>
        <div class="form-group row">
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Miscela caffè scelta</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <display-errors-inline
              :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
              :keys="['order.blend']"
            />
            <blend-select
              :disabled="disabled"
              class="max-size"
              @selected="onBlendSelected"
              :dataKeys="['order', 'blend_id']"
              :idSelected="place.order.blendId"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Prezzo</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <display-errors-inline
              :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
              :keys="['order.price']"
            />
            <inline-editor
              :disabled="disabled"
              inputClasses="text-left borderless p-0 w-100"
              :value="place.order.price"
              type="number"
              :formatter="priceFormatter"
              class="ml-auto my-auto"
              placeholder="Prezzo"
              :dataKeys="['order', 'price']"
              @change="onDataUpdated"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Cons. mensile</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <display-errors-inline
              :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
              :keys="['order.kilograms_per_month']"
            />
            <inline-editor
              :disabled="disabled"
              inputClasses="text-left borderless p-0 w-100"
              :value="place.order.kilogramsPerMonth"
              class="ml-auto my-auto"
              type="number"
              placeholder="Quantità mensile"
              :dataKeys="['order', 'kilograms_per_month']"
              @change="onDataUpdated"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Sconto anticipato</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <inline-editor
              :disabled="disabled"
              inputClasses="text-left borderless p-0 w-100"
              :value="place.order.earlyPaymentDiscount"
              class="ml-auto my-auto"
              type="number"
              placeholder="Sconto anticipato"
              :dataKeys="['order', 'early_payment_discount']"
              @change="onDataUpdated"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Sconto complessivo in €</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <inline-editor
              :disabled="disabled"
              inputClasses="text-left borderless p-0 w-100"
              :value="place.order.earlyPaymentDiscountInMoney"
              class="ml-auto my-auto"
              type="number"
              placeholder="Sconto complessivo in €"
              :dataKeys="['order', 'early_payment_discount_in_money']"
              @change="onDataUpdated"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Termini di pagamento</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <display-errors-inline
              :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
              :keys="['order.payment_method']"
            />
            <payment-method-select
              class="max-size"
              classes="px-0"
              :disabled="disabled"
              @change="onDataUpdated"
              :dataKeys="['order', 'payment_method_id']"
              :idSelected="place.order.paymentMethodId"
            />
          </div>
        </div>
        <div
          class="form-group row"
          v-if="
            (place.version === 1 &&
              place.isOneOf(['customer', 'scheduled', 'completed'])) ||
            (place.version === 2 && canSetContractTypology)
          "
        >
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Tipo di contratto</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <display-errors-inline
              :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
              :keys="[
                place.version === 1
                  ? 'order.contract_type'
                  : 'order.new_contract_type',
              ]"
            />
            <contract-type-select
              class="max-size"
              classes="px-0"
              :disabled="disabled"
              :customItems="place.version === 2 ? contractTypes : null"
              @change="onDataUpdated"
              :dataKeys="[
                'order',
                place.version === 1 ? 'contract_type' : 'new_contract_type',
              ]"
              :idSelected="
                place.version === 1
                  ? place.order.contractTypeId
                  : place.order.newContractType
              "
            />
          </div>
        </div>
        <div class="form-group row" v-if="place.version === 2">
          <label class="col-lg-2 col-md-4 col-7 col-form-label my-auto"
            >Durata del contratto</label
          >
          <div class="col-lg-2 col-md-4 col-7 my-auto">
            <div class="d-flex align-items-center" v-if="!isEditing">
              <display-errors-inline
                :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
                :keys="['order.contract_duration_number']"
              />
              <contract-duration-option-select
                class="max-size flex-grow-1"
                classes="px-0"
                :disabled="disabled"
                @change="onContractDurationOptionChanged"
                :actualDuration="actualDuration"
              />
              <icon
                v-if="!disabled"
                name="Edit"
                class="text-primary clickable flex-grow-0"
                size="sm"
                @click.native.stop="startDurationEditing"
              ></icon>
            </div>
            <div class="d-flex align-items-center" v-if="isEditing">
              <div class="d-flex justify-content-between">
                <inline-editor
                  ref="inlineEditor"
                  inputClasses="borderless p-0 w-100"
                  :value="place.order.contractDurationNumber"
                  class="max-size flex-grow-2"
                  placeholder="Quantità"
                  :dataKeys="['order', 'contract_duration_number']"
                  @change="onDataUpdated"
                />
                <span class="my-auto ml-2 flex-grow-0">
                  {{
                    getTranslatedDurationTypeName(
                      place.order.contractDurationTypeName,
                    )
                  }}</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="form-group row" v-if="showOptionalField(place.order.iban)">
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >IBAN</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <display-errors-inline
              :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
              :keys="['order.iban']"
            />
            <inline-editor
              :disabled="disabled"
              inputClasses="text-left borderless p-0 w-100"
              :value="place.order.iban"
              class="ml-auto my-auto"
              placeholder="IBAN (facoltativo)"
              :dataKeys="['order', 'iban']"
              @change="onDataUpdated"
            />
          </div>
        </div>
        <div
          class="form-group row"
          v-if="showOptionalField(place.order.bankName)"
        >
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Banca</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <display-errors-inline
              :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
              :keys="['order.bank_name']"
            />
            <inline-editor
              :disabled="disabled"
              inputClasses="text-left borderless p-0 w-100"
              :value="place.order.bankName"
              class="ml-auto my-auto"
              placeholder="Banca (facoltativo)"
              :dataKeys="['order', 'bank_name']"
              @change="onDataUpdated"
            />
          </div>
        </div>
        <div
          class="form-group row"
          v-if="showOptionalField(place.order.bankBranch)"
        >
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Filiale</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <display-errors-inline
              :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
              :keys="['order.ibabank_branch']"
            />
            <inline-editor
              :disabled="disabled"
              inputClasses="text-left borderless p-0 w-100"
              :value="place.order.bankBranch"
              class="ml-auto my-auto"
              placeholder="Filiale (facoltativo)"
              :dataKeys="['order', 'bank_branch']"
              @change="onDataUpdated"
            />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Blocco cons. gg</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <display-errors-inline
              :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
              :keys="['order.credit_days']"
            />
            <inline-editor
              :disabled="disabled || currentUser.isAgent"
              inputClasses="text-left borderless p-0 w-100"
              :value="place.order.creditDays"
              class="ml-auto my-auto"
              type="number"
              placeholder="Giorni di blocco consegna"
              :dataKeys="['order', 'credit_days']"
              @change="onDataUpdated"
            />
          </div>
        </div>
        <div
          class="form-group row"
          v-if="place.isOneOf(['customer', 'scheduled', 'completed'])"
        >
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Anni di contratto</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto">
            <display-errors-inline
              :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
              :keys="['order.contract_years']"
            />
            <inline-editor
              :disabled="disabled || !currentUser.isManager"
              inputClasses="text-left borderless p-0 w-100"
              :value="place.order.contractYears"
              class="ml-auto my-auto"
              type="number"
              placeholder="Anni di contratto"
              :dataKeys="['order', 'contract_years']"
              @change="onDataUpdated"
            />
          </div>
        </div>
      </template>
      <p class="page-subtitle">Attrezzatura chiesta in comodato</p>
      <div class="pb-2">
        <p v-if="showEmptyGears" class="text-muted">
          Non ci sono attrezzature in comodato
        </p>
        <order-gear
          v-for="item in place.order.orderGears"
          :key="item.id"
          :item="item"
          @deleted="onOrderGearDeleted"
          :disabled="disabled"
          @updated="onOrderGearUpdated"
        />
        <create-order-gear
          :orderId="place.order.id"
          @created="onOrderGearCreated"
          v-if="!disabled"
        />
      </div>

      <p class="page-subtitle">Accessori marchio Trismoka</p>
      <div class="pb-2">
        <p v-if="showEmptyAccessories" class="text-muted">
          Non ci sono accessori
        </p>
        <order-accessory
          v-for="item in place.order.orderAccessories"
          :key="item.id"
          :item="item"
          @deleted="onOrderAccessoryDeleted"
          :disabled="disabled"
        />
        <create-order-accessory
          :orderId="place.order.id"
          @created="onOrderAccessoryCreated"
          v-if="!disabled"
        />
      </div>
      <p class="page-subtitle">Condizioni speciali</p>
      <div class="pb-2">
        <p v-if="showEmptySpecialConditions" class="text-muted">
          Non ci sono condizioni speciali
        </p>
        <order-special-condition
          v-for="item in place.order.orderSpecialConditions"
          :key="item.id"
          :item="item"
          @deleted="onOrderSpecialConditionDeleted"
          :disabled="disabled"
        />
        <create-order-special-condition
          :orderId="place.order.id"
          @created="onOrderSpecialConditionCreated"
          v-if="!disabled"
        />
      </div>
      <template v-if="canShowInstallationInfo">
        <p class="page-subtitle">Installazione</p>
        <div class="form-group row">
          <display-errors-inline
            :tag="[/candidate_place_.+/, /download_contract_preview_.+/]"
            :keys="['order.installation_date']"
            class="mt-3"
          />
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Data e ora</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto max-size d-flex">
            <input
              class="form-control borderless"
              type="date"
              v-model="date"
              :disabled="disabled"
            />
            <input
              class="form-control borderless ml-2"
              type="time"
              @blur="onDateChanged"
              v-model="time"
              :disabled="disabled"
              v-show="date"
            />
          </div>
        </div>
        <div class="form-group row" v-if="canShowConsignee">
          <label class="col-lg-2 col-md-4 col-12 col-form-label my-auto"
            >Agente consegnatario</label
          >
          <div class="col-lg-10 col-md-8 col-12 my-auto max-size">
            <p class="mb-0">{{ place.consignee.fullname() }}</p>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import InlineEditor, { IDataFormatter } from "components/InlineEditor.vue";
import PaymentMethodSelect from "components/PaymentMethod/Select.vue";
import ContractTypeSelect from "components/ContractType/Select.vue";
import BlendSelect from "components/Blend/Select.vue";
import OrderGear from "components/OrderGear/Item.vue";
import OrderAccessory from "components/OrderAccessory/Item.vue";
import CreateOrderGear from "components/OrderGear/Create.vue";
import CreateOrderAccessory from "components/OrderAccessory/Create.vue";
import CreateOrderSpecialCondition from "components/OrderSpecialCondition/Create.vue";
import DatePicker from "vuejs-datepicker";
const moment = require("moment");
import { ContractDurationOption, Place, User } from "models";
import { showToast } from "utils/Toast";
import OrderSpecialCondition from "components/OrderSpecialCondition/Item.vue";
import ContractDurationOptionSelect from "components/ContractDurationOption/Select.vue";
import Icon from "components/Icon.vue";

@Component({
  components: {
    Icon,
    InlineEditor,
    PaymentMethodSelect,
    ContractTypeSelect,
    DatePicker,
    BlendSelect,
    OrderGear,
    CreateOrderGear,
    OrderAccessory,
    OrderSpecialCondition,
    CreateOrderAccessory,
    CreateOrderSpecialCondition,
    ContractDurationOptionSelect,
  },
})
export default class PlaceOrder extends Vue {
  @Prop({ required: true })
  place: Place;
  isEditing: boolean = false;

  private dateFormatter: IDataFormatter = {
    fromString(value) {
      return value;
    },
    toString(value) {
      return moment(value).format("DD/MM/YYYY");
    },
  };

  private priceFormatter: IDataFormatter = {
    fromString(value) {
      return value;
    },
    toString(value) {
      return new Intl.NumberFormat("it-IT").format(value);
    },
  };

  @Prop({ default: false })
  disabled: boolean;

  @Action setCurrentPlace;

  @Getter currentUser?: User;

  onBlendSelected(data) {
    this.onDataUpdated({
      order: {
        blend_id: data.id,
        price: data.price,
      },
    });
  }

  showOptionalField(value) {
    return (
      (this.currentUser.isExecutive && value) || !this.currentUser.isExecutive
    );
  }

  get contractTypes() {
    return [...Place.contractTypes];
  }

  get date() {
    if (this.place.order.installationDate)
      return moment(this.place.order.installationDate).format("YYYY-MM-DD");
  }

  set date(date) {
    if (date) {
      this.place.order.installationDate = moment(
        date + " " + (this.time || "00:00"),
      );
      if (this.time) {
        this.onDataUpdated({
          order: { installation_date: this.place.order.installationDate },
        });
      }
    }
  }

  get time() {
    if (this.place.order.installationDate)
      return moment(this.place.order.installationDate).format("HH:mm");
  }

  get actualDuration() {
    if (
      !this.place.order.contractDurationTypeName ||
      !this.place.order.contractDurationNumber
    ) {
      return "";
    }
    return (
      this.place.order.contractDurationNumber +
      " " +
      this.getTranslatedDurationTypeName(
        this.place.order.contractDurationTypeName,
      )
    );
  }

  set time(time) {
    if (time) {
      let value = moment(this.date || new Date());
      const timeMoment = moment(time, "HH:mm");
      value.set({
        hour: timeMoment.get("hour"),
        minutes: timeMoment.get("minutes"),
      });
      this.place.order.installationDate = value.toISOString();
    }
  }

  onDateChanged() {
    if (this.date) {
      this.onDataUpdated({
        order: { installation_date: this.place.order.installationDate },
      });
    }
  }

  onDataUpdated(data) {
    this.stopDurationEditing();
    this.$emit("updated", data);
  }

  onContractDurationOptionChanged({
    contractDurationNumber,
    contractDurationTypeName,
  }) {
    this.onDataUpdated({
      order: {
        contract_duration_number: contractDurationNumber,
        contract_duration_type_name: contractDurationTypeName,
      },
    });
  }

  onOrderGearCreated(item) {
    this.place.order.orderGears.push(item);
    showToast("Attrezzatura aggiunta con successo!");
  }
  onOrderGearDeleted(item) {
    this.place.order.orderGears = this.place.order.orderGears.filter(
      (o) => o.id !== item.id,
    );
    showToast("Attrezzatura eliminata con successo!");
  }

  onOrderAccessoryCreated(item) {
    this.place.order.orderAccessories.push(item);
    showToast("Accessorio aggiunta con successo!");
  }

  onOrderSpecialConditionCreated(item) {
    this.place.order.orderSpecialConditions.push(item);
    showToast("Condizione speciale aggiunta con successo!");
  }

  onOrderGearUpdated(item) {
    let orderGears = this.place.order.orderGears;
    const index = orderGears.findIndex((o) => o.id === item.id);
    this.$set(orderGears, index, item);
    this.place.order.orderGears = orderGears;
    this.setCurrentPlace(this.place.clone());
  }

  onOrderAccessoryDeleted(item) {
    this.place.order.orderAccessories =
      this.place.order.orderAccessories.filter((o) => o.id !== item.id);
    showToast("Accessorio eliminata con successo!");
  }

  onOrderSpecialConditionDeleted(item) {
    this.place.order.orderSpecialConditions =
      this.place.order.orderSpecialConditions.filter((o) => o.id !== item.id);
    showToast("Condizione speciale eliminata con successo!");
  }

  get showEmptyGears() {
    return !this.place?.order?.orderGears?.length;
  }

  get canShowConsignee() {
    return this.place.consignee?.id;
  }

  get canShowInstallationInfo() {
    return !this.currentUser.isTechnician;
  }

  get showEmptyAccessories() {
    return !this.place?.order?.orderAccessories?.length;
  }

  get showEmptySpecialConditions() {
    return !this.place?.order?.orderSpecialConditions?.length;
  }

  get canSetContractTypology() {
    return (
      (this.place.isOneOf(["customer", "scheduled", "completed"]) &&
        this.place.version === 1) ||
      this.place.version === 2
    );
  }

  startDurationEditing() {
    this.isEditing = true;
    this.$nextTick(() => {
      (this.$refs.inlineEditor as InlineEditor).enableEditing();
    });
  }

  stopDurationEditing() {
    this.isEditing = false;
  }

  getTranslatedDurationTypeName(typeName) {
    const translation = ContractDurationOption.types.filter(
      (el) => el.id === typeName,
    );
    if (translation.length !== 1) {
      return typeName;
    }
    return translation[0].name;
  }
}
</script>

<style scoped>
.max-size {
  max-width: 18rem;
}
</style>
